import {
  REQUEST_ROCKET_DANON_PATIENTS,
  RESPONSE_ROCKET_DANON_PATIENTS,
  FAILURE_ROCKET_DANON_PATIENTS
} from "../../actions/types";

const initialState = {
  error: false,
  isLoading: false,
  isInitialScreen: true,
  total: 0,
  results: [],
  keyword: "",
  size: 10,
  from: 0,
  activePage: 1
};
const setFetching = (state, action) => {

  return {
    ...state,
    isLoading: true,
    error: false,
    isInitialScreen: false,
  };
};

const setFailure = (state, action) => {
  return {
    ...state,
    isLoading: false,
    error: true,
    results: []
  };
};

const setResults = (state, action) => {
  let results = action.payload.results || {};
  let total = results.total || 0;
  results = results.result || []
  let activePage = action.payload.activePage;

  return {
    ...state,
    isLoading: false,
    error: false,
    results,
    total,
    activePage
  };
};

export default (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_ROCKET_DANON_PATIENTS:
      return setFetching(state, action);
      break;

    case RESPONSE_ROCKET_DANON_PATIENTS:
      return setResults(state, action);

    case FAILURE_ROCKET_DANON_PATIENTS:
      return setFailure(state, action);

    default:
      return state;
      break;
  }
};
